<template>
  <b-dropdown
    ref="dropdown"
    :mobile-modal="false"
    aria-role="menu"
  >
    <b-button
      v-if="smallLabel"
      class="ml-0"
      slot="trigger"
      type="is-primary"
      size="is-small"
      outlined
      rounded
    >{{ smallLabel }}</b-button>

    <b-button
      v-else
      slot="trigger"
      class="set-btn"
      type="is-primary"
      size="is-small"
      outlined
      rounded
      icon-left="pencil"
    ></b-button>

    <b-dropdown-item
      :focusable="false"
      style="min-width: 200px"
      custom
    >
      <b-field v-for="user in $store.getters.activeUsers" :key="user.id">
        <b-checkbox
          v-model="userIdsForm"
          :native-value="user.id"
          size="is-small"
        >{{ user.full_name }}</b-checkbox>
      </b-field>

      <div class="has-text-centered">
        <button-default
          type="is-link"
          size="is-small"
          :loading="isSaving"
          :disabled="isSaving"
          @click="setUsers"
        >Set Users</button-default>
      </div>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
export default {
  props: {
    selectedUsers: Array,
    smallLabel: String
  },
  data() {
    return {
      isSaving: false,
      userIdsForm: []
    }
  },
  computed: {
    activeRecord() {
      return this.$store.state.activeRecord;
    },
    userIds() {
      return this.$utils.clone(this.selectedUsers).map(u => u.id);
    }
  },
  mounted() {
    this.setUserIds();
  },
  methods: {
    setUserIds() {
      this.userIdsForm = this.$utils.clone(this.selectedUsers).map(u => u.id);
    },
    setUsers() {
      const users = this.$store.getters.activeUsers.filter(u => this.userIdsForm.includes(u.id));
      this.$emit('setUsers', users);
      this.$refs.dropdown.$el.click();
    },
    closeModal() {
      this.$root.$emit('closeRecordModal');
    }
  },
}
</script>

<style lang="scss" scoped>
.set-btn {
  border: 1px solid red;
  height: 30px;
  width: 30px;
}
</style>
